import { useFeatureFlag } from '@moda/portal-stanchions';

export const useNewDesktopProductMediaGalleryLayout = (numberOfImages: number) => {
  const enabled = useFeatureFlag('show-expanded-image-layout', [
    { default: false },
    { if: true, then: true }
  ]);

  return enabled && numberOfImages > 1;
};
